import { render } from "./j-text.vue?vue&type=template&id=2f3ae128&scoped=true&ts=true"
import script from "./j-text.vue?vue&type=script&lang=ts"
export * from "./j-text.vue?vue&type=script&lang=ts"

import "./j-text.vue?vue&type=style&index=0&id=2f3ae128&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f3ae128"]])

export default __exports__